export class AssetAttributesModel {
  activeEndDate: '';
  activeFlag: string = '';
  activeStartDate: '';
  assetDescription: string = '';
  assetHierarchyPath: string = '';
  assetID: string = '';
  assetNumber: string = '';
  assetNumber1:string = '';
  assetsImpactsProduction: string = '';
  c1: string = '';
  c2:string = ''
  c3: string = '';
  c4: boolean = false;
  c5: string = '';
  levelNumber: string = '';
}
